import React from "react";
import Card from "../../Reports/templates/Card";
import CreateAlert from "./CreateAlert";
import EditAlert from "./EditAlert";
import i18n from "../../../../utils/ChrI18n";

const ReportMetricForAlert = (props) => {
  const metric = props.metric;
  let actionComponents = [];
  if(metric.allowManage) {
    metric.alertData.configured ? actionComponents.push(EditAlert) : actionComponents.push(CreateAlert);
  }
  const actions = actionComponents.map((ActionComponent => <ActionComponent {...metric.alertData} onTrigger={props.onActionTrigger} />))
  const getTitleSuffix = (metric) => {
    if(metric.alertData.configured){
      return <span className="badge badge-pill mx-2 px-2 badge-info-2">{i18n.t("management_report_v2.alerts.configured")}</span>
    }
  }

  return (
    <Card
      title={metric.title}
      url={metric.url}
      paddingOptions={{ className: "pr-2" }}
      linkOptions={{className: "p-2 text-default" }}
      wrapperOptions={{ className: "cui-hover-effect" }}
      titleOptions={{ className: "py-1 font-14" }}
      titleSuffix={getTitleSuffix(metric)}
      actions={{ pinned: actions }}
    />
  );
};

export default ReportMetricForAlert;
